import { CheckCircle2 } from "lucide-react";
import { PHOTOS } from "@/data";

const EQUIPMENT = ["Heavy Excavators", "Compact Track Skid Steers", "Hydroseed Rigs", "Tandem Dumpers"];

export const About = () => {
  return (
    <section id="about" className="bg-[#0C1827] py-24" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flow-root">
          <figure className="relative mb-10 lg:float-right lg:w-[380px] xl:w-[430px] lg:ml-12 lg:mb-10">
            <div className="absolute -top-4 -right-4 w-24 h-24 border-t-4 border-r-4 border-[#F5A623] rounded-tr-2xl" />
            <img
              src={PHOTOS.gravelPad}
              alt="Fresh gravel pad with armour stone boulders at a Muskoka cottage, built by Almaguin Yard Solutions"
              className="relative rounded-2xl w-full h-72 lg:h-[480px] object-cover shadow-2xl shadow-black/40"
            />
            <figcaption className="absolute -bottom-5 left-5 bg-[#F5A623] rounded-2xl px-5 py-4 shadow-xl">
              <span className="font-display font-black text-xl text-[#0C1827] block">Owner-Operated</span>
              <span className="text-[11px] font-semibold uppercase tracking-wider text-[#0C1827]/70">
                Local Almaguin Crew
              </span>
            </figcaption>
          </figure>

          <span className="font-mono-accent text-xs uppercase tracking-[0.2em] text-[#F5A623]">
            About Us
          </span>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white mt-3 uppercase leading-[1.15] max-w-3xl">
            Built on Hard Work. <span className="text-[#F5A623]">Grounded in Faith.</span> Driven by
            Excellence.
          </h2>
          <p className="mt-6 text-base text-slate-300 leading-relaxed">
            Almaguin Yard Solutions was born in the Highlands — where granite outcrops, deep pine
            roots, and steep slopes demand more than just a lawn tractor. With commercial-grade
            equipment, local expertise, and a hands-on approach, we tackle every project with
            precision and determination.
          </p>
          <p className="mt-4 text-base text-slate-300 leading-relaxed">
            As an owner-operated business, we believe how we do business matters just as much as the
            results we deliver. Our guiding principles are simple: honesty, integrity, respect, and
            excellence. Our faith shapes these values and these values shape every decision, every
            customer relationship, and every job we undertake.
          </p>
          <p className="mt-4 text-base text-slate-300 leading-relaxed">
            When you hire us, the person who quotes your project is the same person running the
            machine. That means direct communication, personal accountability, and a commitment to
            doing what's right — even when no one is watching.
          </p>
          <p className="mt-4 text-base text-slate-300 leading-relaxed">
            From waterfront cottages on Lake Bernard to new builds in Burk's Falls, to cutting new
            laneways in Magnetawan and beyond, our mission is simple: serve people well, work with
            purpose, and leave every property better than we found it.
          </p>
          <p className="mt-4 text-base text-slate-200 leading-relaxed font-semibold">
            That's the Almaguin Yard Solutions difference.
          </p>
          <p className="mt-6 font-mono-accent text-sm uppercase tracking-[0.25em] text-[#F5A623]">
            Precision. Performance. Perfection.
          </p>

          <div className="mt-10 clear-both grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
            {EQUIPMENT.map((item) => (
              <div
                key={item}
                className="flex items-center gap-2.5 text-sm text-slate-200 bg-[#142234] border border-[#1E324A] rounded-xl px-4 py-3"
              >
                <CheckCircle2 size={17} className="text-[#F5A623] shrink-0" />
                {item}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
